module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#strategy",
      toString: function () {
        return this.url;
      }
    }